<template>
  <div  id="app"  >
    <div v-if="!isLoading">
      <AppWrapper />
    </div>
    <div v-else>
    </div>
  </div>
</template>

<script>

import api from "@/lib/callAPI";
import AppWrapper from '@/views/page/AppWrapper.vue';
import { jwtDecode } from 'jwt-decode';

export default {
  name: 'App',
  components: {
    AppWrapper,
  },
  data() {
    return {
      isLoading: true,
    }
  },
  created() {
    this.checkToken()
  },

  methods: {
    async checkToken() {
      this.globalData.token = localStorage.getItem('token');
      if(this.globalData.token){
        const expired = this.isTokenExpired(this.globalData.token);
        if (expired) {
          this.globalData.token = null
          localStorage.setItem('token', null);
        }
      }
      const path = window.location.pathname;
      const token = path.split('/').pop();
      if (token && !this.globalData.token) {
        try {
          this.globalData.token = await api.post('/auth/getToken', {token : token})
          localStorage.setItem('token', this.globalData.token);
        } catch (error) {
          console.error('Lỗi khi giải mã token:', error.message);
        }
      }

      const search = window.location.search;
      const params = new URLSearchParams(search);
      this.globalData.params = {
        id: params.get('id'),
        phone: params.get('phone')
      };
      if (this.globalData.token) {
        try {
          const decodedToken = jwtDecode(this.globalData.token);
          if(decodedToken.account_id && decodedToken.company_code) {

            this.globalData.account_id = decodedToken.account_id
            this.globalData.browser_id = decodedToken.conversation_id
            await api.get('/api/settings/getAccount').then(result => {
              if (result.success) {
                this.globalData.setting = result.data.live_chat_setting;
                this.getRequiredField(result.data.live_chat_setting.is_required_field)
                this.isLoading = false
              }
            });
          }

          const now = Math.floor(Date.now() / 1000);
          const remainingTime = decodedToken.exp - now;
          if (remainingTime < 2 * 24 * 60 * 60) {
            try {
              this.globalData.token =  await api.get('/auth/reNewToken');
              localStorage.setItem('token', this.globalData.token);
            } catch (error) {
              console.error('Lỗi khi renew token:', error.message);
            }
          }

        } catch (error) {
          console.error('Lỗi khi giải mã token:', error.message);
        }
      } else {
        console.warn('Không tìm thấy token!');
      }
    },

    isTokenExpired(token) {
      if (!token) return true;
      try {
        const payloadBase64 = token.split('.')[1];
        const payload = JSON.parse(atob(payloadBase64));

        const now = Math.floor(Date.now() / 1000);
        return payload.exp && payload.exp < now;
      } catch (err) {
        return true;
      }
    },

    getRequiredField(is_required_field) {
      let requiredField = localStorage.getItem('is_required_field');
      if (requiredField === null) {
        localStorage.setItem('is_required_field', JSON.stringify(is_required_field));
        this.globalData.setting.is_required_field = is_required_field;
      } else {
        this.globalData.setting.is_required_field = JSON.parse(requiredField);
      }

    },
  }
}
</script>

<style scoped>

#app{
  font-size: 16px;
  background: transparent;
}
body{
  background: transparent !important;
}
</style>

